import React, { useRef, useState } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import CommentCard from "../../CommentCard";
import { motion, AnimatePresence } from "framer-motion";
import MediaComponent from "../../../MediaComponent";
import ClusterData from "../ClusterData";

function SocialGlassSpotlight({ spotlightData }) {
  const videoRefs = useRef({});
  const idToData = useRef({});
  const [isExpanded, setIsExpanded] = useState(false);

  console.log("spotlight data: ", spotlightData);

  const handleManualMute = (postId) => {
    if (videoRefs.current[postId]) {
      videoRefs.current[postId].muted = true;
    }
  };

  const handleManualUnmute = (postId) => {
    if (videoRefs.current[postId]) {
      videoRefs.current[postId].muted = false;
    }
  };

  return (
    <div className="mt-12 w-full">
      {/* Spotlight Card */}
      <div className="mb-8 rounded-2xl bg-white p-8 shadow-socialglass">
        {/* Header */}
        <div className="mb-2 flex items-start justify-between gap-3">
          <div className="flex items-start gap-3">
            {/* Icon and orange bar side by side */}
            <div className="flex items-center gap-3">
              <span className="inline-flex h-12 w-12 items-center justify-center">
                <img
                  src="/spotlight.svg"
                  alt="Spotlight"
                  width="48"
                  height="48"
                />
              </span>
              <span className="w-2 self-stretch rounded-full bg-orange-500"></span>
            </div>
            <div className="">
              <h2 className="text-xxl flex items-center text-left font-bold leading-tight text-black">
                {spotlightData?.clusterName}{" "}
                {/* <p className="mb-0 ml-4 pb-0 text-base text-gray-500">
                  Missing posts submissions
                </p> */}
              </h2>

              {/* <div className="max-w-xl truncate text-left text-xl text-gray-500">
                Missing spotlight description
                {spotlightData.subtitle}
              </div> */}
            </div>
          </div>

          {/* Dropdown Toggle Button */}
          <motion.button
            onClick={() => setIsExpanded(!isExpanded)}
            className="mt-6 rounded-full p-2 transition-colors hover:bg-gray-100"
            animate={{ rotate: isExpanded ? 0 : -90 }}
            transition={{ duration: 0.3 }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-gray-600"
            >
              <path
                d="M19 9L12 16L5 9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </motion.button>
        </div>

        {/* Main Content */}
        <AnimatePresence>
          {isExpanded && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="mt-10 overflow-hidden"
            >
              <ClusterData
                clusterName={spotlightData?.clusterName}
                clusterData={spotlightData}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default SocialGlassSpotlight;
